import { useEffect, useState } from 'react';

export function useOnboardingPreLogin() {
  const [isFirstTime, setIsFirstTime] = useState<boolean>(false);
  const [isOnboardingVisible, setIsOnboardingVisible] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    checkFirstTime();
  }, []);

  const checkFirstTime = () => {
    try {
      const hasSeenPreLoginOnboarding = localStorage.getItem('vet:hasSeenPreLoginOnboarding');
      const firstTime = !hasSeenPreLoginOnboarding;
      
      setIsFirstTime(firstTime);
      setIsOnboardingVisible(firstTime);
      setIsLoading(false);
    } catch (error) {
      console.error('Erro ao verificar primeiro acesso pré-login:', error);
      setIsLoading(false);
    }
  };

  const completeOnboarding = () => {
    try {
      localStorage.setItem('vet:hasSeenPreLoginOnboarding', 'true');
      setIsFirstTime(false);
      setIsOnboardingVisible(false);
    } catch (error) {
      console.error('Erro ao salvar estado do onboarding pré-login:', error);
    }
  };

  const skipOnboarding = () => {
    completeOnboarding();
  };

  const resetOnboarding = () => {
    try {
      localStorage.removeItem('vet:hasSeenPreLoginOnboarding');
      setIsFirstTime(true);
      setIsOnboardingVisible(true);
    } catch (error) {
      console.error('Erro ao resetar onboarding pré-login:', error);
    }
  };

  return {
    isFirstTime,
    isOnboardingVisible,
    isLoading,
    completeOnboarding,
    skipOnboarding,
    resetOnboarding,
    setIsOnboardingVisible
  };
}